import { Image } from '@heroui/react';
import styled from 'styled-components';

interface StyledImageInterface {
  borderRadius?: string;
  width?: string;
  height?: string;
}

export const StyledImageContainer = styled.div<StyledImageInterface>`
  position: relative;
  width: ${({ width }) => width ?? '100%'};
  height: ${({ height }) => height ?? '100%'};
  clip-path: border-box;
  border-radius: ${({ borderRadius }) => borderRadius ?? 0};
  overflow: hidden;
`;

export const StyledImageWrapper = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; 
  object-fit: cover;
  border-radius: 0;
`;
